import React, {
    useContext,
    useState
} from 'react';
import { useMutation } from '@tanstack/react-query';

import { NotificationContext, handleError } from '../context/NotificationContext';
import { refetchBasketData } from "../queries/global";

import * as QUERIES from "../queries/query-functions";

import TicketQuantityButtons from "../components/ticket-quantity-buttons"
import LoadingIndicator from '../components/loading-indicator';
import useTimedMessage from '../hook/useTimedMessage';

export default function ExtrasInstance(props) {
    const {notification, setNotification} = useContext(NotificationContext);
    const [ticketQuantity, setTicketQuantity] = useState(props.instance.event?.attribute_TicketQuantityLogic == "Per Ticket" && props.instanceTickets ? props.instanceTickets.length : 1);
    const price = props.instance?.priceList?.prices ? props.instance.priceList.prices[0] : null;
    const { message: successMessage, setMessage: setSuccessMessage, fadeOut } = useTimedMessage(3000);

    const addTickets = useMutation({
        mutationFn: () => QUERIES.addTickets(ticketQuantity, price.ticketType.id, "", props.instance.id, props.instance.planId),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: () => {
            setSuccessMessage("Tickets are added to basket.")
            refetchBasketData();
        },
    });

    if (props.isAccountPage && props.instance.event.attribute_ExcludeFromAccountUpsell === true) {
        return null;
    }

    return (
        <article className='extras-instance'>
            <div className='extras-instance__img'>
                {props.instance.event.thumbnailUrl && <img src={props.instance.event.thumbnailUrl } />}
            </div>
            <div className='extras-instance__content'>            
                <header className='extras-instance__header'>
                    <div className='extras-instance__header--content'>
                        <h3 className='extras-instance__title'>{ props.instance.event.name }</h3>

                        { price && (
                            <p className='extras-instance__price'>
                                { price.amount === 0
                                    ? 'Free'
                                    : `£${ price.amount.toFixed(2) }`
                                }
                            </p>
                        )}
                    </div>
                </header>

                <div className='extras-instance__summary stack'>
                    {props.instance.event?.htmlDescription ?
                        <p dangerouslySetInnerHTML={{__html: props.instance.event.htmlDescription}}></p>
                    : props.instance.event?.description ?
                        <p>{ props.instance.event.description }</p>
                    :null}
                </div>

                <div className='extras-instance__footer'>
                    <TicketQuantityButtons ticketQuantity={ticketQuantity} setTicketQuantity={setTicketQuantity} />

                    {!successMessage ?
                        <button className='btn' 
                            type="button" 
                            onClick={() => { addTickets.mutateAsync(); setSuccessMessage(null)}}
                            disabled={addTickets.isPending}>
                            Add to basket
                            {addTickets.isPending &&
                                <LoadingIndicator />
                            }
                        </button>
                        :<p class="btn btn--purple-neutral100">Added to basket</p>
                    }
                </div>

            </div>

            {/* {successMessage &&
                <p className={`confirmation-message ${fadeOut ? "fade-out" : ""}`}>{successMessage}</p>
            } */}
        </article>
    );
}